import React, { useState, useEffect, useRef } from 'react';
import validIcon from "../../assets/images/register/green_check.svg";
import editIcon from '../../assets/images/register/edit.png';
import ReactGA from "react-ga";
import Cookies from "universal-cookie";
import { useSelector } from 'react-redux';

const CareersRegisterInputOtp = (props) => {
  const cookies = new Cookies();
  const [otp, setOtp] = useState('');
  const [error, setError] = useState(null);
  const [focused, setFocused] = useState(false);
  const { loginData, loginDataLoading } = useSelector((state) => state.usersCommonData)

  useEffect(() => {
    if (props.usersLoginSignupOtp) {
      props.setIsResending(true);
    }
  }, [props.usersLoginSignupOtp])

  useEffect(() => {
    props.setRemainingSeconds(Math.abs(localStorage.getItem("remainingSeconds") ? Math.abs(30 - Math.abs(localStorage.getItem("remainingSeconds") - new Date().getSeconds())) : 0))
  }, [])

  useEffect(() => {
    const countdownInterval = setInterval(() => {
      if (props.remainingSeconds > 0) {
        props.setRemainingSeconds(prevSeconds => prevSeconds - 1);
      } else {
        clearInterval(countdownInterval);
      }
    }, 1000);
    if (props.remainingSeconds < 3) {
      localStorage.removeItem("remainingSeconds");
    }
    return () => clearInterval(countdownInterval);
  }, [props.remainingSeconds])

  useEffect(() => {
    if (loginDataLoading) {
      setError(null)
    } else if (loginData?.otp_response == false && props.values.otp?.length == 4 && loginData?.otp_on) {
      setError(loginData?.message)
    }
  }, [loginData, loginDataLoading])

  const handleResendClick = () => {
    setOtp("");
    setError(null);
    props.setFormikValues((prev) => ({...prev, "otp": ""}));
    props.setReinitialize(true)
    setTimeout(() => props.setReinitialize(false), 50);
    props.setIsResending(true);
    props.setResendTimer(30);
  };

  const handleChange = (e) => {
    const sanitizedValue = e.target.value?.replace(/[^\d]/g, '');
    props.setFieldValue("otp", sanitizedValue);
    setOtp(sanitizedValue);
  };
  return (
    <div className={error || (loginData?.otp_response == false && otp?.length == 4) ? "careers_register_form_card invalid_field multi_check_padding" : otp ? "careers_register_form_card white_bg multi_check_padding" : "careers_register_form_card multi_check_padding"}>
      <div className="otp_field_input">
        <input
          type="text"
          name={props.name}
          className="input_type_text"
          value={otp}
          inputMode="numeric"
          maxLength={4}
          onChange={(e) => {
            handleChange(e)
          }}

          onFocus={() => {
            setFocused(true)
          }}
          onBlur={() => { setFocused(false) }}
          required />
      </div>
      <span className={focused || otp ? "floating_label_active" : "floating_label"}>
        Please enter OTP
      </span>

      {/* Resend OTP */}
      {props.remainingSeconds ? (
        <div className="resend_otp resend_otp_disabled">
          <span className='resend_otp_deactivate'>Resend OTP in</span>
          <span className='resend_otp_time'>
            <span>{`${props.remainingSeconds % 60}`}</span> sec
          </span>
        </div>
      ) : (
        <div onClick={() => { handleResendClick(); props.otpGetClicked(); props.resetTimer() }} className="resend_otp">
          <span className='resend_otp_active'>Resend OTP</span>
        </div>
      )}

      {/* Valid Icon */}
      {/* <img src={validIcon} alt="careers_register_checkIcon" className='careers_register_valid_icon' /> */}

      {/* Invalid Card */}
      {error &&
        <div className="invalid_card">
          <span className="invalid_card_text">{error}</span>
        </div>}

      {/* Edit Field */}
      {/* <div className="edit_card">
                <img src={editIcon} alt="edit_icon" />
                <span>Edit</span>
            </div> */}
    </div>
  )
}

export default CareersRegisterInputOtp;